var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{attrs:{"id":"postEditorFooter"}},[_c('tool-bar-status-btn'),_vm._v(" "),_c('PostWordsCounter'),_vm._v(" "),_c('ConfirmHeading')],1)}
var staticRenderFns = []

export { render, staticRenderFns }